import { apiClient } from './client'

export interface TwoFactorMethod {
  method: 'authenticator' | 'email' | 'sms'
  status: 'pending' | 'active' | 'disabled'
  enabledAt?: string
  lastUsedAt?: string
  displayName: string
}

export interface TwoFactorStatus {
  enabled: boolean
  methods: TwoFactorMethod[]
}

export interface AuthenticatorSetupResponse {
  secret: string
  qrCodeUrl: string
  manualEntryKey: string
  backupCodes: string[]
}

export interface VerificationResult {
  success: boolean
  message: string
  backupCodesUsed?: boolean
}

// Get user's 2FA status
export const get2FAStatus = async (): Promise<TwoFactorStatus> => {
  const response = await apiClient.get('/2fa/status')
  return response.data.data
}

// Setup authenticator app 2FA
export const setupAuthenticator = async (): Promise<AuthenticatorSetupResponse> => {
  const response = await apiClient.post('/2fa/setup/authenticator')
  return response.data.data
}

// Setup email 2FA
export const setupEmail = async (): Promise<{ message: string }> => {
  const response = await apiClient.post('/2fa/setup/email')
  return response.data.data
}

// Setup SMS 2FA
export const setupSMS = async (): Promise<{ message: string }> => {
  const response = await apiClient.post('/2fa/setup/sms')
  return response.data.data
}

// Verify 2FA setup
export const verifySetup = async (method: string, code: string): Promise<VerificationResult> => {
  const response = await apiClient.post('/2fa/verify/setup', { method, code })
  return response.data.data
}

// Verify 2FA during login
export const verifyLogin = async (userId: string, userType: string, code: string): Promise<VerificationResult> => {
  const response = await apiClient.post('/2fa/verify/login', { userId, userType, code })
  return response.data.data
}

// Send email verification code
export const sendEmailCode = async (): Promise<{ message: string }> => {
  const response = await apiClient.post('/2fa/send/email')
  return response.data.data
}

// Send SMS verification code
export const sendSMSCode = async (): Promise<{ message: string }> => {
  const response = await apiClient.post('/2fa/send/sms')
  return response.data.data
}

// Disable 2FA method
export const disableMethod = async (method: string): Promise<{ message: string }> => {
  const response = await apiClient.delete(`/2fa/disable/${method}`)
  return response.data.data
}

// Generate new backup codes
export const generateBackupCodes = async (): Promise<{ backupCodes: string[] }> => {
  const response = await apiClient.post('/2fa/backup-codes/generate')
  return response.data.data
}